export default "__VITE_ASSET__5YZ1gGLi__"